export const SUMMARY = "SUMMARY";
export const SHOW_SUMMARY = "SHOW_SUMMARY";
export const WEEKLY_SCHEDULE = "WEEKLY_SCHEDULE";
export const SHOW_WEEKLY_SCHEDULE = "SHOW_WEEKLY_SCHEDULE";
export const BILLING_CHART = "BILLING_CHART";
export const SHOW_BILLING_CHART = "SHOW_BILLING_CHART";
export const AVERAGE_TICKET = "AVERAGE_TICKET";
export const SHOW_AVERAGE_TICKET = "SHOW_AVERAGE_TICKET";
export const PAYMENT_KIND = "PAYMENT_KIND";
export const SHOW_PAYMENT_KIND = "SHOW_PAYMENT_KIND";
export const LOADING_DATA = "LOADING_DATA";
export const BRAND_CHART = "BRAND_CHART";
export const SHOW_BRAND_CHART = "SHOW_BRAND_CHART";

export const CHARTS_BEGIN_DATE = "CHARTS_BEGIN_DATE";
export const CHARTS_END_DATE = "CHARTS_END_DATE";
export const UPDATE_CHARTS = "UPDATE_CHARTS";
export const CHART_SCOPE = "CHART_SCOPE";

export const WALLET = "WALLET";
export const IS_LOADING = "IS_LOADING";
export const LOAD = "LOAD";
export const GET_SUMMARY = "GET_SUMMARY";
export const GET_WEEKLY_SCHEDULE = "GET_WEEKLY_SCHEDULE";
export const GET_BILLING_CHART = "GET_BILLING_CHART";
export const GET_AVERAGE_TICKET = "GET_AVERAGE_TICKET";
export const GET_PAYMENT_KIND = "GET_PAYMENT_KIND";
export const GET_BRAND_CHART = "GET_BRAND_CHART";
export const GET_WALLET = "GET_WALLET";

//filters
export const SET_FILTER_ORDINATION = "SET_FILTER_ORDINATION";
